module.exports = __webpack_public_path__ + "static/img/join-yx2.2d4f2a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/join-yx2.png
// module id = 4pbT
// module chunks = 1